module.exports = __webpack_public_path__ + "static/assets/480dfbd7bb60e2f2b57304877b25a9d0.svg";